// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fp2A","label":"styles_label__2-PF4"};